<template>
	<section
		:class="[
			'card card-fast-payment',
			{
				active: displayFormFastPayment,
				small:
					(!showMTransfer || !showPaynow) &&
					currentUser &&
					!currentUser.sso,
				noPayment: !showMTransfer && !showPaynow,
			},
		]"
	>
		<h2 @click="showMTransfer || showPaynow ? showForm() : ''">
			zasil rachunek fx
			<img
				src="images/icons/chevron-down-green.svg"
				:class="{ 'upside-down': displayFormFastPayment }"
			/>
		</h2>
		<div v-if="showMTransfer || showPaynow">
			<transition tag="div" name="card-collapse" mode="out-in">
				<div>
					<fast-payment-form
						v-show="displayFormFastPayment"
						:key="1"
					/>
					<fast-payment-preview
						v-show="!displayFormFastPayment"
						:key="2"
					/>
				</div>
			</transition>
		</div>
		<div v-else style="margin-top: 20px">
			Przepraszamy, na ten moment zasilenie rachunku jest niemożliwe.<br />
			Prosimy spróbować później.
		</div>
	</section>
</template>

<script>
import FastPaymentForm from '@/views/dashboard/partial/_FastPaymentForm';
import FastPaymentPreview from '@/views/dashboard/partial/_FastPaymentPreview';
import { mapGetters } from 'vuex';

export default {
	components: {
		FastPaymentForm,
		FastPaymentPreview,
	},
	methods: {
		showForm() {
			this.$store.commit(
				'setDisplayFormFastPayment',
				!this.displayFormFastPayment
			);
			this.$store.commit('setDisplayFormPayout', false);
			this.$store.commit('setDisplayFormAccounts', false);
		},
	},
	computed: {
		displayFormFastPayment() {
			return this.$store.getters.getDisplayFormFastPayment;
		},
		...mapGetters({
			showMTransfer: 'getShowMTransfer',
			showPaynow: 'getShowPaynow',
			currentUser: 'getCurrentUser',
		}),
	},
};
</script>
